"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabLink = exports.TabButton = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const tabSizeStyle = (size) => {
    switch (size) {
        case 'lg':
            return 'px-6 py-5 lg:px-10 text-2xl font-bold font-display';
        default:
            return 'px-4 py-4 lg:px-10 text-sm font-bold font-body';
    }
};
const getTabStyle = ({ active, size, className }) => {
    return (0, classnames_1.default)('inline-block rounded-t-lg border-t border-l border-r focus:outline-none focus:ring focus:ring-blue-4/40 border-grey-3', active ? 'bg-white text-black ' : 'bg-slate-1 text-blue-5 border-b', tabSizeStyle(size), className);
};
const TabButton = ({ onClick, children, ...styleProps }) => {
    return (react_1.default.createElement("button", { className: getTabStyle(styleProps), onClick: onClick }, children));
};
exports.TabButton = TabButton;
const TabLink = ({ to, children, ...styleProps }) => {
    return (react_1.default.createElement(react_router_dom_1.Link, { to: to, className: getTabStyle(styleProps) }, children));
};
exports.TabLink = TabLink;
